<template>
  <div>
    <vxe-form
      title-colon
      ref="xForm"
      :data="formData"
      :rules="rules"
      v-if="is_need==1"
    >
      <vxe-form-gather span="12">
      <vxe-form-item field="value4" :item-render="{}" title-overflow>
        <template #default="scope">
          <vxe-pulldown :disabled="disabled" size="mini" ref="xDown" transfer>
            <template #default>
              <vxe-input
                :disabled="disabled"
                v-model="formData.value4"
                ref="vxeInput"
                suffix-icon="fa fa-search"
                :placeholder="placeholder"
                @keyup="keyupEvent"
                @click="clickEvent"
                @suffix-click="suffixClick"
                @focus="getFoucs"
                @blur="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
            <template #dropdown>
              <div class="my-dropdown4">
                <vxe-grid
                  ref="vxeGrid"
                  highlight-hover-row
                  highlight-current-row
                  auto-resize
                  size="small"
                  height="300"
                  :loading="loading"
                  :pager-config="tablePage"
                  :data="tableData"
                  :columns="tableColumn"
                  @cell-dblclick="doubleEvent"
                  @cell-click="selectEvent"
                  @page-change="pageChangeEvent"
                  @keydown="keydownEvent"
                  :keyboard-config="{ isArrow: true }"
                  :edit-config="{ trigger: 'keydown', mode: 'cell' }"
                >
                </vxe-grid>
              </div>
            </template>
          </vxe-pulldown>
        </template>
      </vxe-form-item>
      </vxe-form-gather>
    </vxe-form>


<vxe-pulldown v-if="is_need==0" :disabled="disabled" size="mini" ref="xDown" transfer>
            <template #default>
              <vxe-input
                :disabled="disabled"
                v-model="formData.value4"
                ref="vxeInput"
                suffix-icon="fa fa-search"
                :placeholder="placeholder"
                @keyup="keyupEvent"
                @click="clickEvent"
                @suffix-click="suffixClick"
                @focus="getFoucs"
              ></vxe-input>
            </template>
            <template #dropdown>
              <div class="my-dropdown4">
                <vxe-grid
                  ref="vxeGrid"
                  highlight-hover-row
                  highlight-current-row
                  auto-resize
                  size="small"
                  height="300"
                  :loading="loading"
                  :pager-config="tablePage"
                  :data="tableData"
                  :columns="tableColumn"
                  @cell-dblclick="doubleEvent"
                  @cell-click="selectEvent"
                  @page-change="pageChangeEvent"
                  @keydown="keydownEvent"
                  :keyboard-config="{ isArrow: true }"
                  :edit-config="{ trigger: 'keydown', mode: 'cell' }"
                >
                </vxe-grid>
              </div>
            </template>
          </vxe-pulldown>


  </div>
</template>
<script>
// import { props } from 'node_modules/vue-barcode'
import request from "../../utils/request";
  import _ from "lodash";
import { cmpPos } from 'codemirror';
export default {
  name: "DownTable",
  props: {
    requestUrl: "",
    columnData: Array,
    parent: Object, // 暂未使用
    params: "",
    placeholder: "",
    disabled: false,
    rowName:'',   //要显示的值字段
    is_need:0
  },
  watch: {
    //   value4:{
    //   deep: true,
    //   immediate:true,
    //    handler: function(e) {
    //     this.$emit('getVal',e)
    //   }
    // },
    row: {
      deep: true,
      immediate: true,
      handler: function (e) {
        let a = JSON.stringify(e);
        this.$emit("getVal", a);
      },
    },
    params: {
      deep: true,
      immediate: true,
      handler: function (e) {
        this.formData.value4 = e;
      },
    },
  },
  data() {
    return {
      loading: false,
      // value4: "",
      tableData: [],
      tableColumn: [],
      fetchTableData: [],
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 50, 100],
      },
      row: {},
      formData: {
        value4: "",
      },
      rules: {
        value4: [{ required: true, message: "请输入信息", trigger: "" }],
      },
    };
  },
  created() {
    this.load();
  
    if(this.placeholder!=''){
      this.rules.value4[0].message='请输入'+this.placeholder
    }
  },
  mounted() {
    this.keyupEvent = _.debounce(this.keyupEvent, 300);
  },
  methods: {
    getFoucs() {
      this.load();
    },
    load() {
      if (this.columnData.length > 0) this.tableColumn = this.columnData;
      //   const { row, column } = this.params
      //   this.row = row
      //   this.column = column
      this.formData.value4 = this.params;
      this.fetchData().then((data) => {
        this.tableData = data;
      });
    },
    async fetchData() {
      await request({
        url: this.requestUrl,
        method: "get",
        params: {
          keyword: this.formData.value4,
          pageSize: this.tablePage.pageSize,
          page: this.tablePage.currentPage,
        },
      })
        .then((res) => {
          if (res.code == 200) {
            this.fetchTableData = res.data.list;
            this.tablePage.total = res.data.count;
          }
        })
        .catch((err) => {});

      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.fetchTableData);
        }, 0);
      });
    },
    keydownEvent(params) {
      const { $event, $grid } = params;
      if ($event.keyCode == 27) {
        // Escape 取消
        this.$refs.xDown.hidePanel();
      }
      if ($event.keyCode == 13) {
        const currRow = $grid.getCurrentRecord();
        this.formData.value4 = currRow.name;
        this.row = currRow;
        this.$refs.xDown.hidePanel();
      }
    },
    pageChangeEvent({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.loading = true;
      this.fetchData().then((data) => {
        this.loading = false;
        this.tableData = data;
      });
    },
    doubleEvent(params) {
      this.row = params.row;
      // 更新原始row数据
      this.tableColumn.forEach((item) => {
        if (item.type != "seq" && item.field) {
         
          
          if(this.rowName==''||this.rowName==undefined){
            this.formData.value4 = params.row.name;
          }else{
            let rname=this.rowName
            this.formData.value4 =params.row[rname]
          }
          this.row = params.row;
        }
      });

      this.$refs.xDown.hidePanel();
      // 触发父表格更新
      //   this.params.$table.updateStatus({ row, column });
    },

    selectEvent(params) {
      // console.log('单击: ', params)
      // const { row, column } = this
      // row[column.property] = params.row.name
      // this.$refs.xDown.hidePanel()
    },

    keyupEvent(params) {
      const { $event, value } = params;
      // const { row, column } = this;
      const cellValue = params.value;

      if (
        $event.keyCode == 40 ||
        $event.keyCode == 13 ||
        $event.keyCode == 38
      ) {
        // ArrowDown 下箭头 ， Enter 回车 ， ArrowUp 上箭头
        this.$refs.vxeInput.blur();
        setTimeout(() => {
          this.$refs.vxeGrid.focus();
          if (!this.$refs.vxeGrid.getCurrentRecord())
            this.$refs.vxeGrid.setCurrentRow(this.tableData[0]);
        }, 0);
        return;
      }

      this.loading = true;
      this.fetchData().then((data) => {
        this.loading = false;
        this.$refs.xDown.showPanel();
        // if (cellValue) {
        //   this.tableData = data.filter(item => item.name.indexOf(cellValue) > -1)
        // } else {
        this.tableData = data;
        // }
      });
    },
    suffixClick() {
      this.$refs.xDown.togglePanel();
    },
    clickEvent() {
      this.$refs.xDown.showPanel();
    },
  },
};
</script>
<style>
.vxe-input {
  width: 170px;
}
.vxe-input.is--suffix .vxe-input--inner {
  /* border-right: none; */
  border-radius: 4px 0 0 4px;
}
.vxe-form .vxe-form--item{
  padding: 0;
}

</style>